'use client'

import { useState, useEffect } from 'react'
import Link from 'next/link'

export const STORAGE_KEY = 'vibe-cookie-consent'
export const PREFERENCES_EVENT = 'open-cookie-preferences'

export default function CookieBanner() {
  const [mounted, setMounted] = useState(false)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!mounted || typeof window === 'undefined') return
    const consent = localStorage.getItem(STORAGE_KEY)
    if (!consent) {
      setVisible(true)
    }
  }, [mounted])

  useEffect(() => {
    if (!mounted || typeof window === 'undefined') return
    const handler = () => {
      localStorage.removeItem(STORAGE_KEY)
      setVisible(true)
    }
    window.addEventListener(PREFERENCES_EVENT, handler)
    return () => window.removeEventListener(PREFERENCES_EVENT, handler)
  }, [mounted])

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted')
    setVisible(false)
  }

  const handleReject = () => {
    localStorage.setItem(STORAGE_KEY, 'rejected')
    setVisible(false)
  }

  if (!mounted || !visible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-zinc-900 border-t border-zinc-800 px-4 py-4 md:px-6 md:py-5 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 max-w-5xl">
        <p className="text-zinc-300 text-sm md:text-base text-center sm:text-left">
          Utilizamos cookies para melhorar sua experiência e manter sua sessão. Ao continuar, você concorda com nossa{' '}
          <Link href="/privacidade" className="text-[#ffa300] hover:underline">
            Política de Privacidade
          </Link>
          .
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={handleReject}
            className="px-4 py-2.5 text-sm font-medium text-zinc-400 hover:text-white transition-colors border border-zinc-600 rounded-lg hover:bg-zinc-800"
          >
            Rejeitar
          </button>
          <button
            onClick={handleAccept}
            className="px-5 py-2.5 text-sm font-bold text-black bg-[#ffa300] rounded-lg hover:bg-[#ff8c00] transition-colors"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  )
}
